import { useField } from 'formik'
import { FloatingLabelField, FloatingLabelFieldProps } from './FloatingLabelField'

type FormikFloatingLabelFieldProps = Omit<FloatingLabelFieldProps, 'value' | 'onChange' | 'onBlur' | 'error'> & {
  name: string
}

export const FormikFloatingLabelField = (props: FormikFloatingLabelFieldProps) => {
  const [field, meta] = useField(props.name)
  const error = meta.touched && meta.error ? meta.error : undefined

  return (
    <FloatingLabelField
      {...props}
      value={field.value ?? ''}
      onChange={field.onChange}
      onBlur={field.onBlur}
      error={error}
    />
  )
}
